"use client";

export default function GlobalError({ reset }) {
  return (
    <html lang="de">
      <body className="bg-neutral-950 text-gray-200">
        <main className="flex min-h-screen items-center justify-center p-6">
          <section className="max-w-lg rounded-xl border border-neutral-800 bg-neutral-900 p-8 text-center">
            <h1 className="text-xl font-semibold">Ein unerwarteter Fehler ist aufgetreten</h1>
            <p className="mt-3 text-sm text-gray-400">
              Bitte versuche es erneut. Wenn der Fehler bestehen bleibt, prüfe die
              Anwendungslogs.
            </p>
            <button
              type="button"
              onClick={() => reset()}
              className="mt-6 rounded-md bg-aurora-500 px-4 py-2 text-sm font-medium text-neutral-950"
            >
              Erneut versuchen
            </button>
          </section>
        </main>
      </body>
    </html>
  );
}
